import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { zodResolver } from '@hookform/resolvers/zod';
import { Grid, Stack } from '@mui/material';
import { FormContainer } from 'react-hook-form-mui';
import { NameField } from '../components/form/name.field';
import { SurnameField } from '../components/form/surname.field';
import { UserGroupField } from '../components/form/UserGroupField';
import { UserRoleField } from '../components/form/UserRoleField';
import { EditUserValues, editUserSchema } from './edit-user.schema';

interface Props {
  values: EditUserValues;
  onSubmit: (data: EditUserValues) => Promise<any>;
}

export function EditUserForm({ values, onSubmit }: Props) {
  return (
    <FormContainer values={values} onSuccess={onSubmit} resolver={zodResolver(editUserSchema)}>
      <Stack spacing={4} useFlexGap>
        <Grid container spacing={2}>
          <Grid item md={3}>
            <NameField />
          </Grid>
          <Grid item md={3}>
            <SurnameField />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item md={5}>
            <UserRoleField />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item md={5}>
            <UserGroupField />
          </Grid>
        </Grid>

        <FormActionsMui />
      </Stack>
    </FormContainer>
  );
}
